import debounce from 'lodash.debounce';

const MOBILE_BP = 768; // $bp--tablet-xl

class Tooltip {
  constructor() {
    this.isIE11 =
      navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;
    this.isMobile = window.innerWidth < MOBILE_BP;

    this.bindEvents();
  }

  bindEvents() {
    this.terms = document.querySelectorAll('.tooltip__term');
    this.terms.forEach(term => {
      term.addEventListener('mouseenter', e =>
        this.setTooltipPosition(e, term.parentNode.querySelector('.tooltip__definition')),
      );
    });

    window.addEventListener('resize', debounce(this.onResize.bind(this), 500));
  }

  onResize() {
    this.isMobile = window.innerWidth < MOBILE_BP;
  }

  setTooltipPosition(e, tooltipEl) {
    const target = e.target;
    const windowWidth = window.innerWidth;
    const tooltipWidth = tooltipEl.offsetWidth;
    const tooltipHeight = tooltipEl.offsetHeight;
    const targetX = target.getBoundingClientRect().left;
    const targetY = target.getBoundingClientRect().top;

    if (this.isIE11 && !this.isMobile) {
      tooltipEl.classList.add('ie11');
      return;
    }

    // Set horizontal position
    const maxTooltipX = targetX + target.offsetWidth + tooltipWidth + 50; // 50px margin
    const minTooltipX = targetX - tooltipWidth - 50;

    // Tooltip should stay within minTooltipX and maxTooltipX
    if (windowWidth > maxTooltipX) {
      // Position tooltip on right
      tooltipEl.classList.add('right');
      tooltipEl.classList.remove('left');
    } else if (0 < minTooltipX) {
      // Position tooltip on left
      tooltipEl.classList.add('left');
      tooltipEl.classList.remove('right');
    }

    // Set vertical position
    let plantBioY = false;
    const plantBioStory = target.closest('.plant-bio__story');

    if (plantBioStory) {
      plantBioY = plantBioStory.getBoundingClientRect().top;
    }

    const isTooltipCroppedByViewport = tooltipHeight + 50 > targetY; // 50px margin
    const isTooltipCroppedByColumn = plantBioY && tooltipHeight > (targetY - plantBioY);

    // Tooltip should stay within top of viewport or column
    if (isTooltipCroppedByViewport || isTooltipCroppedByColumn) {
      tooltipEl.classList.add('bottom');
    } else {
      tooltipEl.classList.remove('bottom');
    }
  }
}

export default Tooltip;
